import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['activationCheckbox', 'settingsSection', 'voteKeyField', 'voteKeyForm'];

  declare activationCheckboxTarget: HTMLInputElement;
  declare settingsSectionTarget: HTMLElement;
  declare voteKeyFieldTarget: HTMLInputElement;
  declare voteKeyFormTarget: HTMLFormElement;

  private submitTimeout: number | null = null;

  public toggleSetting(_event: any): void {
    if (this.activationCheckboxTarget.checked) {
      this.settingsSectionTarget.classList.add("active");
    } else {
      this.settingsSectionTarget.classList.remove("active");
    }
  }

  // Submit vote key form when key field changes
  public submitVoteKeyOnChange(_event: any): void {
    // Clear any existing timeout
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
    }

    // Debounce the submission to avoid excessive requests
    this.submitTimeout = setTimeout(() => {
      this.submitVoteKeyForm();
    }, 500); // Wait 500ms after user stops typing
  }

  // Submit vote key form immediately when field loses focus
  public submitVoteKeyOnBlur(_event: any): void {
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
    }
    this.submitVoteKeyForm();
  }

  private submitVoteKeyForm(): void {
    if (this.hasVoteKeyFormTarget) {
      // Use the native form submission which Turbo will intercept for remote forms
      this.voteKeyFormTarget.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  disconnect(): void {
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
    }
  }
}
